<template>
  <!-- eslint-disable -->
  <div class="custom-modal-overlay" @click.self="closeModal">
    <div class="custom-modal-content">
      <div class="modal-content-enhanced" v-if="order">
        <!-- HEADER -->
        <div class="modal-header-enhanced">
          <div class="modal-icon" :style="{
            background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors
              ? `linear-gradient(135deg, ${prestador.admin.assets.colors.primary}, ${prestador.admin.assets.colors.secondary})`
              : 'linear-gradient(135deg, #3b82f6, #1d4ed8)'
          }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
            </svg>
          </div>
          <div class="modal-title-section">
            <h5 class="modal-title">{{ order.nombre }} {{ order.apellido1 }}</h5>
            <p class="modal-subtitle">{{ formatTime(order.desde) }} - {{ formatTime(order.hasta) }}</p>
          </div>
          <span class="status-badge-large" :class="getStatusBadgeClass(order)">
            {{ getStatusText(order.estado) }}
          </span>
        </div>

        <!-- BODY -->
        <div class="modal-body-enhanced">
          <!-- Información -->
          <div class="info-grid">
            <!-- Paciente -->
            <div class="info-section">
              <h6 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                Información del Paciente
              </h6>
              <div class="info-items">
                <div class="info-item">
                  <span class="info-label">Nombre completo:</span>
                  <span class="info-value">{{ order.nombre }} {{ order.apellido1 }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">RUT:</span>
                  <span class="info-value">{{ order.rut || 'No disponible' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Teléfono:</span>
                  <span class="info-value">{{ order.telefono || 'No disponible' }}</span>
                </div>
              </div>
            </div>

            <!-- Profesional -->
            <div class="info-section">
              <h6 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="8.5" cy="7" r="4" />
                  <path d="M20 8v6" />
                  <path d="M23 11h-6" />
                </svg>
                Profesional Asignado
              </h6>
              <div class="info-items">
                <div class="info-item">
                  <span class="info-label">Nombre:</span>
                  <span class="info-value">{{ getProfessionalName(order) }} {{ getProfessionalLastName(order) }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Horario:</span>
                  <span class="info-value">{{ formatTime(order.desde) }} - {{ formatTime(order.hasta) }}</span>
                </div>
              </div>
            </div>

            <!-- Dirección -->
            <div class="info-section">
              <h6 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Dirección del Servicio
              </h6>
              <div class="info-items">
                <div class="info-item">
                  <span class="info-label">Dirección:</span>
                  <span class="info-value">{{ order.direccion || 'No disponible' }}</span>
                </div>
                <div class="info-item" v-if="order.n_depto">
                  <span class="info-label">Departamento:</span>
                  <span class="info-value">{{ order.n_depto }}</span>
                </div>
                <div class="info-item" v-if="order.comuna_id">
                  <span class="info-label">Comuna:</span>
                  <span class="info-value">{{ comunaNombre }}</span>
                </div>
              </div>
            </div>

            <!-- Estado -->
            <div class="info-section">
              <h6 class="section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="3" />
                  <path d="M12 1v6m0 6v6" />
                  <path d="M21 12h-6m-6 0H3" />
                </svg>
                Estado de la Orden
              </h6>
              <div class="info-items">
                <div class="info-item">
                  <span class="info-label">Estado:</span>
                  <span class="info-value">{{ getStatusText(order.estado) }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Fecha creación:</span>
                  <span class="info-value">{{ order.fecha_creado_dt || 'No disponible' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">Prestador:</span>
                  <span class="info-value">{{ order.prestador || 'No disponible' }}</span>
                </div>
              </div>
              <select v-model="order.estado" class="status-select no-menu"
                @change="cambiarEstado2(order.id, order.estado)">
                <option v-for="(e, z) in estados" :value="z">{{
                  e
                }}</option>
              </select>
            </div>
          </div>

          <!-- Servicios -->
          <div v-if="order.examenes && order.examenes.length" class="info-section full-width">
            <h6 class="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
              </svg>
              Servicios Solicitados
            </h6>
            <div class="services-grid">
              <div v-for="exam in order.examenes" :key="exam.id" class="service-item">
                <div class="service-icon"
                  :style="{ background: prestador && prestador.admin && prestador.admin.assets && prestador.admin.assets.colors ? prestador.admin.assets.colors.primary : '#3b82f6' }">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                  </svg>
                </div>
                <span class="service-name">{{ exam.nombre }}</span>
              </div>
            </div>
          </div>

          <!-- Comentarios -->
          <div v-if="order.comentarios && order.comentarios.length" class="info-section full-width">
            <h6 class="section-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
              Comentarios
            </h6>
            <div class="comments-list">
              <div v-for="comment in order.comentarios" :key="comment.id" class="comment-item">
                <div class="comment-header">
                  <span class="comment-date" v-if="formatCommentDate && comment.fecha">
                    {{ formatCommentDate(comment.fecha) }}
                  </span>
                  <span class="comment-date" v-else-if="comment.fecha">
                    {{ comment.fecha.d }}/{{ comment.fecha.m }}/{{ comment.fecha.a }}
                  </span>
                </div>
                <p class="comment-text">{{ comment.texto || 'Sin comentario' }}</p>
              </div>
            </div>
            <button class="close-btn" @click="$emit('close')">×</button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";

export default {
  name: "ModalCalendario",
  props: {
    order: Object,
    prestador: Object,
    comunas: Array,
    formatTime: Function,
    getStatusBadgeClass: Function,
    getStatusText: Function,
    getProfessionalName: Function,
    getProfessionalLastName: Function,
  },
  data() {
    return {
      estados: ["Anulado", "Citado", "Confirmado", "Atendido", "No Atendido"],
    }
  },
  methods: {
    cambiarEstado2(o, e) {

      axios
        .post(window.hostname + "/api/admin/cambiarEstado", {
          orden_id: o,
          estado_id: e
        })
        .then(response => {
          this.popup = false;
          this.$notify({
            group: "foo",
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado exitosamente!",
            type: "success"
          });
        })

        .catch(e => {
          console.log(e.response);
          this.$notify({
            group: "foo",
            title: "¡Error!",
            text: "¡Ha ocurrido un error!",
            type: "error"
          });
        });
    },

    closeModal() {
      this.$emit('close');
    }
  },
  computed: {
    comunaNombre() {
      const comuna = this.comunas.find(c => c.id === this.order.comuna_id);
      return comuna ? comuna.Nombre : '';
    },
  }

};
</script>

<style scoped>
/* Fondo oscuro que cubre toda la pantalla */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Fondo semi-transparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* Muy por encima del resto */
}

/* Caja del modal */
.custom-modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px;
  /* Más ancho que el de Bootstrap */
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
}

/* Encabezado del modal */
.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

/* Estilos idénticos a los que tenías originalmente */
.modal-content-enhanced {
  padding: 0;
}

.modal-header-enhanced {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.modal-title-section {
  flex: 1;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 0.25rem;
}

.modal-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 0.875rem;
}

.status-badge-large {
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modal-body-enhanced {
  padding: 2rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.info-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.2s ease;
}

.info-section:hover {
  border-color: #cbd5e1;
}

.info-section.full-width {
  grid-column: 1 / -1;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 1rem;
}

.info-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e2e8f0;
  gap: 1rem;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 500;
  color: #64748b;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.info-value {
  font-weight: 600;
  color: #1a202c;
  text-align: right;
  word-break: break-word;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.75rem;
}

.service-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.service-item:hover {
  border-color: #cbd5e1;
}

.service-icon {
  width: 20px;
  height: 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.service-name {
  font-weight: 500;
  color: #1a202c;
  font-size: 0.875rem;
}

.comments-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.comment-item {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.2s ease;
}

.comment-item:hover {
  border-color: #cbd5e1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.comment-author {
  font-weight: 600;
  color: #1a202c;
  font-size: 0.875rem;
}

.comment-date {
  font-size: 0.75rem;
  color: #64748b;
}

.comment-text {
  color: #374151;
  margin: 0;
  line-height: 1.5;
  font-size: 0.875rem;
}

.status-select {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.2s ease;
}

.status-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
</style>